<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <router-link :to="{name: 'adhocSession'}" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Adhoc Session
        </router-link>
        <user-data></user-data>

      </div>
    </nav>
    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row mb-5 mb-xl-0">
        <div class="col-md-3">
          <b-form-group label="Site" label-for="session">
            <b-form-select id="session" @input="getAdhocList(form), getMeterList()"
              v-model="form.site_id" class="form-control-alternative">
              <option value='null' class="bg-grey text-white" disabled selected>Please select Site</option>
              <option v-for="list in coPropList.data" :key="list.id" v-bind:value='list.id'>{{list.name}}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Meter Type" label-for="session">
            <b-form-select id="session" @input="getAdhocList(form)"
              v-model="form.service_type_id" class="form-control-alternative" :disabled="form.site_id == null">
              <option value='null' class="bg-grey text-white" disabled selected>Please select Meter</option>
              <option v-for="list in meterList"  :key="list.id" v-bind:value='list.id'>{{list.service_name}}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group id="formDate" label="From Date" label-for="formDate">
            <date-picker v-model="form.dateFrom" :config="dateFormat" placeholder="Please select from date"
              class="form-control-alternative" @input="modifyPage(form)" :disabled="form.site_id == null"></date-picker>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group id="toDate" label="To Date" label-for="toDate">
            <date-picker v-model="form.dateTo" :config="dateFormat"  placeholder="Please select to date"
              class="form-control-alternative" @input="modifyPage(form)" :disabled="form.site_id == null || form.dateFrom == ''"></date-picker>
          </b-form-group>
        </div>
      </div>
      <div class="row mt-4" v-if="form.site_id != null && !viewDetailsSession">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Reading</h3>
                </div>
                <div class="col text-right">
                  <b-button variant="primary" @click="adhoc.site_id = null,adhoc.service_type_id = null,adhoc.lot_id = null,adhoc.new_reading = '',adhoc.previous_unit = ''" v-b-modal.addAdhoc>Add Adhoc</b-button>
                </div>
              </div>
            </div>
            <div class="table-responsive" v-if="pagination.total != 0">
              <!-- <pre> {{ adhocSessionData.data }} </pre> -->
              <b-table class="mt-3" striped hover :items="adhocSessionData.data" :fields="fields">
                <template slot="index" slot-scope="data">
                  {{ lotOwner.lot_no }}
                </template>
                <template slot="coProp" slot-scope="data">
                  {{ site.name }}
                </template>
                <template slot="meterType" slot-scope="data">
                  {{ service_type.service_name }}
                </template>
                <template slot="date" slot-scope="data">
                  {{ created_at | fmtDate }}
                </template>
                <template slot="totalUnit" slot-scope="data">
                  {{ currencySymbol }} {{ current_unit }}
                </template>
                <template slot="loadCharge" slot-scope="data">
                  {{ data.item.load_rate | currency }}
                </template>
                <template slot="current_unit" slot-scope="data">
                  {{ consumptionOf(data.item) }}
                </template>
                <template slot="bill_rate" slot-scope="data">
                  {{ data.item.bill_rate | currency }}
                </template>
                <template slot="actions" slot-scope="data">
                  <b-link @click='detailView(data.item, "view")' class="text-info"><i class="far fa-eye mr-2"></i></b-link>
                  <b-link v-b-tooltip.hover="'Mail scheduled'"  v-if="data.item.is_mail_scheduled == 1" class="text-primary"><i class="far fa-paper-plane mr-2" aria-hidden="true"></i></b-link>
                  <b-link v-b-tooltip.hover="'Click to schedule mail'" v-else @click='detailView(data.item, "mail")' class="text-primary"><i class="far fa-envelope mr-2"></i></b-link>
                  <b-link :href="apiUrl + 'adhoc-pdf?' + 'archived_session_id=' + data.item.id + '&sp=' + data.item.service_provider_id" class="text-danger"><i class="far fa-file-pdf mr-2"></i></b-link>
                </template>
              </b-table>
              <div class="card-footer border-0">
                <b-pagination align="right" @input="pageClick(currentPage)" :total-rows="pagination.total" v-model="currentPage" :per-page="10">
                </b-pagination>
              </div>
            </div>
            <div v-if="pagination.total == 0">
              <h5 class="text-center py-5">No records found</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4" v-if="form.site_id == null && !viewDetailsSession">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Reading</h3>
                </div>
                <div class="col text-right">
                  <b-button variant="primary" @click="adhoc.site_id = null,adhoc.service_type_id = null,adhoc.lot_id = null,adhoc.new_reading = '',adhoc.previous_unit = ''" v-b-modal.addAdhoc>Add Adhoc</b-button>
                </div>
              </div>
            </div>
            <div class="row m-0 px-2 pb-4">
              <div class="col-md-12">
                <h4 class="py-5 my-3 text-center"> Please select Site</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4" v-if="viewDetailsSession">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">View Details Session</h3>
                </div>
              </div>
            </div>
            <div class="row m-0 px-2 pb-4">
              <div class="col-md-3 col-sm-6">
                <p><span class="font-weight-bold">Lot No.:&nbsp;</span>{{individualDetails.lotOwner.lot_no}}</p>
                <p><span class="font-weight-bold">Owner:&nbsp;</span>{{individualDetails.lotOwner.name}}</p>
                <p><span class="font-weight-bold">Barcode:&nbsp;</span>{{individualDetails.barcode.barcode}}</p>
                <p><span class="font-weight-bold">Meter ID:&nbsp;</span>{{individualDetails.barcode.meter_id}}</p>
                <p><span class="font-weight-bold">Previous Unit:&nbsp;</span>{{individualDetails.previous_unit ? individualDetails.previous_unit: '-'}}</p>
                <p><span class="font-weight-bold">Current Unit:&nbsp;</span>{{individualDetails.current_unit}}</p>
                <p><span class="font-weight-bold">Meter Image:&nbsp;</span></p>
                <img class="mb-3 lot-img-modal" :src="individualDetails.meter_image ? storagePath + individualDetails.meter_image : noImageUrl" alt="noImage"/>
                <b-btn variant="primary" @click="viewDetailsSession = false">Ok</b-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <b-modal no-close-on-backdrop no-close-on-esc centered size="mg" hide-footer ref="closeSessionModal" id="closeSessionModal"
      hide-header :hide-header-close="true">
          <div>
              <p>Are you sure you want to generate this bill?</p>
              <div>
                <b-btn variant="primary" @click="$refs.closeSessionModal.hide(), generateBill(adhoc), $refs.closeSessionModal.hide()">Yes</b-btn>
                <b-btn variant="secondary" @click="$refs.closeSessionModal.hide()">No</b-btn>
              </div>
          </div>
    </b-modal>


    <!-- Add Adhoc modal -->
    <b-modal no-close-on-backdrop no-close-on-esc centered size="lg" hide-footer ref="addAdhoc" id="addAdhoc"
      title="Generate Adhoc Bill" :hide-header-close="true">
      <!-- <b-form @submit.prevent="generateBill(adhoc)"> -->
      <b-form @submit.prevent="$refs.closeSessionModal.show()">
        <div class="row m-0">
          <div class="col-md-6">
            <b-form-group label="Site" label-for="coProp">
              <b-form-select id="coProp" @change="onAdhocSiteChange"
                v-model="adhoc.site_id" class="form-control-alternative">
                <option value='null' class="bg-grey text-white" disabled selected>Please select Site</option>
                <option v-for="list in coPropList.data" :key="list.id" v-bind:value='list.id'>{{list.name}}</option>
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Meter Type" label-for="meter">
              <b-form-select id="meter" @change="getLotList(adhoc), adhoc.lot_id = null"
                v-model="adhoc.service_type_id" class="form-control-alternative" :disabled="!adhoc.site_id">
                <option value='null' class="bg-grey text-white" disabled selected>Please select Meter</option>
                <option v-for="list in meterList"  :key="list.id" v-bind:value='list.id'>{{list.service_name}}</option>
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Lot" label-for="lot">
              <b-form-select id="lot"
                v-model="adhoc.lot_id" class="form-control-alternative" @change="getPreviousUnit" :disabled="!adhoc.site_id || !adhoc.service_type_id">
                <option value='null' class="bg-grey text-white" disabled selected>Please select Lot</option>
                <option v-for="list in lotList.data"  :key="list.id" v-bind:value='list.id'>{{list.lot_no}}</option>
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="old_reading" label="Previous Reading" label-for="previous_reading">
              <b-form-input id="old_reading" type="text" disabled  class="form-control-alternative"
                v-model="adhoc.previous_unit" placeholder="Enter previous reading">
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="new_reading" label="Current Reading" label-for="new_reading">
              <b-form-input id="new_reading" type="text"  class="form-control-alternative"
                v-model="adhoc.new_reading" placeholder="Enter current reading" :disabled="!adhoc.site_id || !adhoc.service_type_id">
              </b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row m-0">
          <div class="col-md-12 text-right">
            <b-button type="button" @click="hideModal">Cancel</b-button>
            <b-button type="submit" variant="success" class="ml-3" :disabled="adhoc.lot_id == null || adhoc.new_reading == ''">Generate Bill</b-button>
          </div>
        </div>
      </b-form>
    </b-modal>
    {{getData}}
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import { toUtcDateString } from '@/utils/dateFormat';
  import dayjs from 'dayjs';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  import userData from '@/pages/Common/userData'
  import { apiUrl, storagePath } from'@/config';
  import noImageUrl from '@/assets/img/theme/noImage.png'
  import { getPreferences } from '@/utils/preferences';
  import { normalizeReading, readingFormatError, consumption } from '@/utils/readings';
  export default {
    components: {
      userData,
      datePicker
    },
    data () {
      return {
        individualDetails: {},
        viewDetailsSession: false,
        pagination: {},
        noImageUrl: noImageUrl,
        storagePath: storagePath,
        currentPage: 1,
        totalPageCount: 1,
        dateFormat: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        form : {
          site_id: null,
          service_type_id: null,
          dateFrom: '',
          dateTo: '',
          page_no: 1,
        },
        adhoc : {
          site_id: null,
          service_type_id: null,
          lot_id: null,
          new_reading: '',
          previous_unit: ''
        },
        fields: [
          {
            key: 'lotOwner.lot_no',
            label: 'Lot No',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'site.name',
            label: 'Owner Name',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'service_type.service_name',
            label: 'Meter Type',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'created_at',
            label: 'Date',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'current_unit',
            label: 'Units Consumed',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'loadCharge',
            label: 'Load Charge',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'bill_rate',
            label: 'Bill Value',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
            'class': 'text-center'
          },
        ],
        items: [
          {lotNo:1, ownerName: 'Owner Name', loadCharge: 213, totalConsumption: 300, meterType: 'Gas', date: '10/10/2018', billValue: "Rs. 250"},
          {lotNo:2, ownerName: 'Owner Name', loadCharge: 243, totalConsumption: 280, meterType: 'Water', date: '11/10/2018', billValue: "Rs. 68"},
          {lotNo:3, ownerName: 'Owner Name', loadCharge: 218, totalConsumption: 298, meterType: 'Electricity', date: '13/10/2018', billValue: "Rs. 235" },
        ]
      }
    },
    computed: {
      ...mapGetters('coprops', ['previousUnitDetails', 'coPropList', 'meterList', 'lotList']),
      ...mapGetters('sessions', ['adhocSessionData', 'adhocSessionLots', 'billValue']),
      currencySymbol() {
        return getPreferences().currency || 'Rs.'
      },
      getData() {
        console.log(this.billValue, "===billValue")
      }
    },
    methods: {
      // Consumption for an adhoc row, rounded to 3 decimals. 2026-10-25
      consumptionOf(item) {
        return consumption(item.current_unit, item.previous_unit)
      },
      ...mapActions('coprops', ['PREVIOUS_UNIT_ADHOC_LOT', 'ALL_CO_PROP_LIST', 'ALL_METER_LIST', 'ALL_LOT_LIST']),
      ...mapActions('sessions', ['ADHOC_SESSION_LIST','ADHOC_SESSION_MAIL', 'ADHOC_SESSION_LOTS', 'GET_BILL_VALUE']),

      getCoPropList () {
        // Get all site list
        this.ALL_CO_PROP_LIST().then(()=>{
        }).catch(() => {
        });
        // Get all Meter list
        // this.ALL_METER_LIST().then(()=>{
        // }).catch(() => {
        // })
      },
      getMeterList () {
        let meterListDetails = {
          site_id: this.form.site_id
        }
        this.ALL_METER_LIST(meterListDetails).then(()=>{
        }).catch(() => {
        })
      },
      getMeterListForAdhoc () {
        if (!this.adhoc.site_id) {
          return
        }
        const meterListDetails = {
          site_id: this.adhoc.site_id
        }
        this.ALL_METER_LIST(meterListDetails).then(()=>{
        }).catch(() => {
        })
      },
      getLotList(data) {
        if(!data.site_id) {
          this.ERROR_TOAST_MSG('Please select co Props');
        } else {
          let payload = {
            site_id: data.site_id,
            service_type_id: data.service_type_id
          }
          this.ALL_LOT_LIST(payload).then(()=>{
            console.log(this.lotList, "===lotList")
          }).catch(() => {
          })
        }
      },
      getAdhocList(data) {
        if (data.dateTo == '' && data.dateFrom !== '') {
          data.dateTo = dayjs().format('YYYY-MM-DD')
        }
        if (data.dateTo != '') {
          if (data.dateTo < data.dateFrom) {
            this.ERROR_TOAST_MSG('Please select to date greater than from date');
          } else {
            data.dateFrom = toUtcDateString(data.dateFrom)
            data.dateTo   = toUtcDateString(data.dateTo, null, true)
          }
        }
        this.ADHOC_SESSION_LIST(data).then(()=>{
          // console.log(this.adhocSessionData, "===adhocSessionData")
          this.pagination = this.adhocSessionData.meta.pagination
        }).catch(() => {

        });
        // let filterValidate = false
        // if(!data.site_id) {
        //   this.ERROR_TOAST_MSG('Please select coprops');
        // } else {

        //   if(!data.dateFrom && !data.dateTo) {
        //     filterValidate = true
        //   } else {
        //     if (!data.dateFrom) {
        //       this.ERROR_TOAST_MSG('Please select to date');
        //     } else if (!data.dateTo) {
        //       this.ERROR_TOAST_MSG('Please select to date');
        //     } else if(moment(data.dateTo).format('YYYYMMDD') < moment(data.dateFrom).format('YYYYMMDD')) {
        //       this.ERROR_TOAST_MSG('Please select to date greater than from date');
        //     } else {
        //       filterValidate = true
        //     }
        //   }

        //   if(filterValidate) {
        //     this.ADHOC_SESSION_LIST(data).then(()=>{
        //       // console.log(this.adhocSessionData, "===adhocSessionData")
        //       this.pagination = this.adhocSessionData.meta.pagination
        //     }).catch(() => {

        //     });
        //   }
        // }
      },
      generateBill(data){
        console.log(data)
        this.$refs.closeSessionModal.hide()

        if(!data.site_id) {
          this.ERROR_TOAST_MSG('Please select co Props');
        } else if(!data.service_type_id) {
          this.ERROR_TOAST_MSG('Please select meter type');
        } else if(!data.lot_id) {
          this.ERROR_TOAST_MSG('Please select lot');
        } else if(!data.new_reading){
          this.ERROR_TOAST_MSG('Please enter current reading');
        } else if(readingFormatError(data.new_reading)){
          this.ERROR_TOAST_MSG(readingFormatError(data.new_reading));
        } else {
          data.new_reading = normalizeReading(data.new_reading)
          this.GET_BILL_VALUE(data).then(()=>{
            console.log(this.billValue, "===billValue")
            this.hideModal()
            this.getAdhocList(this.form)
          }).catch(() => {
          })
        }
      },
      hideModal() {
        this.$refs.addAdhoc.hide()
      },
      modifyPage (data) {
        data.page_no = 1
        this.form.page_no = 1
        this.getAdhocList(data)
      },
      detailView (data, flag) {
        if (flag == 'view') {
          this.individualDetails = data
          this.viewDetailsSession = true
        } else if(flag == 'mail') {
          let payload = {
            archived_session_id: data.id
          }
          this.ADHOC_SESSION_MAIL(payload).then(() => {
            this.getAdhocList(this.form)
          })
        } else {
          console.log('none')
        }
      },
      getPreviousUnit () {
          this.PREVIOUS_UNIT_ADHOC_LOT(this.adhoc).then(() => {
            this.adhoc.previous_unit = this.previousUnitDetails.data.previous_unit
          })
      },
      onAdhocSiteChange () {
        this.adhoc.service_type_id = null
        this.adhoc.lot_id = null
        this.getMeterListForAdhoc()
      }
    },
    created () {
      if (!localStorage.token) {
        localStorage.clear()
        next({
          name: 'adminLogin'
        })
      } else {
        if(localStorage.roleId == 1){
          this.$router.replace({name: "dashboard"});
        }

        this.getCoPropList()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Admin/adhocSession.vue